import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule],
  templateUrl: './progress-spinner.component.html',
  styleUrl: './progress-spinner.component.scss'
})
export class ProgressSpinnerComponent {
  @Input() color: ThemePalette = 'primary';
  @Input() diameter: number = 100;
  @Input() strokeWidth: number = 10;
  @Input() mode: 'determinate' | 'indeterminate' = 'indeterminate';
}
